/** Részletes statisztika grafikon — autónként detailed_stats flag. */
export function isDetailedStatsUnlocked(cars, carId = "all") {
  if (!Array.isArray(cars) || cars.length === 0) return false;
  if (carId === "all") return cars.some((c) => c.detailed_stats);
  const car = cars.find((c) => c.id === carId);
  return !!car?.detailed_stats;
}
